// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__11cZl","content":"styles_content__23gxz","checkbox":"styles_checkbox__1ssI-","checkboxLabel":"styles_checkboxLabel__ko0Go"};